export const CUSTOM_FORMULA_LIST_RECEIVED = "CUSTOM_FORMULA_LIST_RECEIVED";
export const FAVORITE_FORMULA_LIST_RECEIVED = "FAVORITE_FORMULA_LIST_RECEIVED";
export const CLASSIC_FORMULA_LIST_RECEIVED = "CLASSIC_FORMULA_LIST_RECEIVED";
export const ALL_HERB_LIST_RECEIVED = "ALL_HERB_LIST_RECEIVED";
export const SINGLE_HERB_ADDED_TO_LIST = "SINGLE_HERB_ADDED_TO_LIST";
export const SINGLE_HERB_ITEM_EDITED = "SINGLE_HERB_ITEM_EDITED,";
export const SINGLE_HERB_REMOVED_FROM_LIST = "SINGLE_HERB_REMOVED_FROM_LIST";
export const FORMULA_BY_ID_RECEIVED = "FORMULA_BY_ID_RECEIVED";
export const SUBCLASS_BY_ID_RECEIVED = "SUBCLASS_BY_ID_RECEIVED";
export const MODIFICATION_BY_ID_RECEIVED = "MODIFICATION_BY_ID_RECEIVED";
export const HERBS_BY_ID_RECEIVED = "HERBS_BY_ID_RECEIVED";
export const DISEASES_RECEIVED = "DISEASES_RECEIVED";
export const MODIFICATION_BY_FORMULA_ID_RECEIVED =
  "MODIFICATION_BY_FORMULA_ID_RECEIVED";
export const HERBS_BY_FORMULA_ID_RECEIVED = "HERBS_BY_FORMULA_ID_RECEIVED";
export const ADDITIONAL_HERB_ADDED_TO_FORMULA =
  "ADDITIONAL_HERB_ADDED_TO_FORMULA";
export const FORMULA_REMOVED_FROM_SECTION = "FORMULA_REMOVED_FROM_SECTION";
export const HERB_REMOVED_FROM_FORMULA = "HERB_REMOVED_FROM_FORMULA";
export const FORMULA_HERB_ITEM_EDITED = "FORMULA_HERB_ITEM_EDITED";
export const FORMULA_TYPE_CHANGED = "FORMULA_TYPE_CHANGED";
export const FORMULA_TYPE_CHANGED_FROM_RAW_TO_GRANULAR =
  "FORMULA_TYPE_CHANGED_FROM_RAW_TO_GRANULAR";
export const FORMULA_TYPE_CHANGED_FROM_GRANULAR_TO_RAW =
  "FORMULA_TYPE_CHANGED_FROM_GRANULAR_TO_RAW";
export const SINGLE_HERB_TOTAL_CHANGED = "SINGLE_HERB_TOTAL_CHANGED";
export const FORMULA_TOTAL_CHANGED = "FORMULA_TOTAL_CHANGED";
export const OVERALL_TOTAL_CHANGED = "OVERALL_TOTAL_CHANGED";
export const SINGLE_HERB_FROM_PRESCRIPTION_ADDED_TO_LIST =
  "SINGLE_HERB_FROM_PRESCRIPTION_ADDED_TO_LIST";
export const RENDER_FORMULA_LIST = "RENDER_FORMULA_LIST";
export const FORMULA_LOCKED = "FORMULA_LOCKED";
export const SINGLE_HERB_LIST_LOCKED = "SINGLE_HERB_LIST_LOCKED";
export const SET_ACTIVE_CUSTOM_FORMULA = "SET_ACTIVE_CUSTOM_FORMULA";
export const ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED =
  "ACUMATICA_FORMULA_BY_FORMULA_ID_RECEIVED";
export const SINGLE_HERBS_POSITION_CHANGED = "SINGLE_HERBS_POSITION_CHANGED";
export const FORMULA_HERBS_POSITION_CHANGED = "FORMULA_HERBS_POSITION_CHANGED";
export const RESTORE_RAW_HERBS = "RESTORE_RAW_HERBS";
